import { Typography } from 'antd';
import { type ConfigType } from 'dayjs';
import React from 'react';

import RelativeTime from './relative-time';

function UpdatedAt({
  value,
}: {
  value: ConfigType | null | undefined;
}): React.ReactElement | null {
  if (!value) {
    return null;
  }

  return (
    <Typography.Text type="secondary">
      Updated <RelativeTime value={value} />
    </Typography.Text>
  );
}

export default UpdatedAt;
